import {StoppageGroup} from '@domain/shared'
import {StoppageInfo} from '@domain/stoppages'
import {AnalysisType, AnalysisStatus, AnalysisPrivacyStatus} from '@hconnect/common/types'

import {rootCauseTypes} from '../consts/analysis.consts'

export type AnalysisUserPermissions = {
  canCreate: boolean
  canContribute: boolean
  canEdit: boolean
  canView: boolean
  canManageActions: boolean
  canAddAttachment: boolean
  canDeleteAttachment?: boolean
  canDelete: boolean
  canFinish: boolean
  canReopen?: boolean
  canSetOwner: boolean
  canSetPlant: boolean
}

export interface RcfaUserInfo {
  id: string
  name?: string
  email?: string
}

type AnalysisCoreFields = {
  id: number
  title: string
  description: string
  owner: RcfaUserInfo
  createDate: string
  permissions: AnalysisUserPermissions
  privacyStatus: string
  updateDate: string
  areaTypeCode?: string
  category?: string
  dueDate?: string
}

type AnalysisListOptional = {
  stoppageCode?: string
  stoppageCodeText?: string
  stoppageStart?: string
  stoppageEnd?: string
  contributors?: number
  groupStoppages?: StoppageGroup[]
}

export type AnalysisListInfo = AnalysisCoreFields &
  AnalysisListOptional & {
    plant: string
    status: AnalysisStatus
    stoppageIsDeleted: string
    hasPendingTasks: boolean
    country: string
  }

export interface AnalysisInfo extends AnalysisCoreFields {
  contributors: Array<RcfaUserInfo>
  plant: string
  plantId: string
  status: string
  type: AnalysisType
}

export interface AnalysisFull extends AnalysisCoreFields {
  contributors: Array<RcfaUserInfo>
  equipmentName?: string
  plantId: string
  privacyStatus: AnalysisPrivacyStatus
  status: AnalysisStatus
  stoppage?: StoppageInfo
  type: 'Custom' | 'Cockpit'
}

export interface GraphLevel {
  nodes: Array<Node>
  level: number
}
export type RootCauseType = (typeof rootCauseTypes)[number]

export enum Probability {
  unknown = 'Unknown',
  likely = 'Likely',
  unlikely = 'Unlikely',
  inconclusive = 'Inconclusive'
}

interface NodeVote {
  id: number
  nodeId: number
  vote: Vote
  isMyVote: boolean
  owner: RcfaUserInfo
}

export interface VoteList {
  currentUserVote?: Probability
  likelyCount?: number
  likelyPercentage?: number
  probability: Probability
  unlikelyCount?: number
  votes: ReadonlyArray<NodeVote>
}

export enum Vote {
  likely = 'likely',
  unlikely = 'unlikely'
}

export interface Node {
  attachmentCount: number
  causeProbability: Probability
  children?: Array<number>
  commentCount: number
  dependsOn?: Array<number>
  description?: string
  id: number
  index?: number
  isOnPathToRootCauseFrom?: Array<number>
  rootCauseType?: RootCauseType
  level?: number
  order?: number
  parent?: number
  taskCount: number
  title: string
  votes: VoteList | undefined
}
